import { Query } from 'apollo-angular';
import { Injectable } from '@angular/core';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class PTMIntermediateQuery extends Query<any, {}> {
  document = gql`
    query ptmIntermediate($friendlyId: String) {
      pTMs(where: { friendlyId: $friendlyId }) {
        nombrePublico
        tituloPaginaIntermedia
        descripcionPaginaIntermedia
        cardImg {
          url
          alt
        }
        pD {
          tituloPaginaIntermedia
          descripcionPaginaIntermedia
          imagenPaginaIntermedia {
            url
            alt
          }
          friendlyId
        }
        friendlyId
        metaDescripciones {
          nombreTag
          contenidoTag
          contenidoImagen {
            url
          }
        }
      }
    }
  `;
}
